define(['app/modules/forms'], function(Forms) {
  var Email_templates = function () {};

  Email_templates.prototype.actionNew = Email_templates.prototype.actionEdit = function() {
    if ($('.checkbox-icheck').parent('[class*="icheckbox"]').hasClass("checked")) {
      $('.reply-to').show();
    }

    $('.checkbox-icheck').on('ifChecked', function() {
      $('.reply-to').show();
    });

    $('.checkbox-icheck').on('ifUnchecked', function() {
      $('.reply-to').hide();
    });

    $('form').on('submit', function(e){
      e.preventDefault();
      for (instance in CKEDITOR.instances) {
        CKEDITOR.instances[instance].updateElement();
      }
      Forms.submit($(this), '', function(){document.location.href = document.location.origin + '/preferences/email_templates'});
    });
  };

  return Email_templates;
});